import { render } from "./relationSwiperTool.vue?vue&type=template&id=1d756857&scoped=true"
import script from "./relationSwiperTool.vue?vue&type=script&lang=js"
export * from "./relationSwiperTool.vue?vue&type=script&lang=js"

import "./relationSwiperTool.vue?vue&type=style&index=0&id=1d756857&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d756857"]])

export default __exports__